// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2PeMN","modalFooterButton":"ModalNotes_modalFooterButton__38CsI"};